module.exports = __webpack_public_path__ + "img/1321264922.22f540e9.jpg";